import styled from "styled-components";

export const ImageDivider = styled.div`
  width: 1px;
  background-color: #2b2b2b;
`;
